import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const InstallPermissionsSaveCallbackContext = /*#__PURE__*/createContext(undefined);
export function InstallPermissionsSaveCallbackProvider({
  onInstallPermissionsSave,
  children
}) {
  return /*#__PURE__*/_jsx(InstallPermissionsSaveCallbackContext.Provider, {
    value: {
      onInstallPermissionsSave
    },
    children: children
  });
}
export function useInstallPermissionsSaveCallback() {
  const context = useContext(InstallPermissionsSaveCallbackContext);
  if (context === undefined) {
    throw new Error('useInstallPermissionsSaveCallback must be used within an InstallPermissionsSaveCallbackProvider');
  }
  return context;
}